import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { quickMenuApi } from "../../api/quickMenu/quickMenuApi";
import {
  getQuickMenu,
  setQuickMenu,
} from "../../modules/reducers/landing/quickMenu";
import { nbQuickMenu, edQuickMenu } from "../../features/Landing/dummy/quickMenu";
import { brandIdMap } from "../../features/Search/const/brandIdMap";

const useQuickMenu = () => {
  const menuItems = useSelector((state) => state.quickMenu.menuItems);
  const brandId = useSelector((state) => state.checkArsStatus.brandId);
  const storeId = useSelector((state) => state.checkArsStatus.branchId);
  const tempUserId = useSelector((state) => state.checkArsStatus.userId);
  const userId = tempUserId??"".replaceAll(' ', '+');
  const selectedBranchId = useSelector(
    (state) => state.getBranches.selectedBranchId
  );

  const loading = useSelector((state) => state.quickMenu.loading);

  const dispatch = useDispatch();

  useEffect(() => {
    if (brandId === "NB") {
      dispatch(setQuickMenu(nbQuickMenu));
    }
    if (brandId === "ED") {
      dispatch(setQuickMenu(edQuickMenu));
    }
  }, []);

  useEffect(() => {
    const api = quickMenuApi();
    const brandCd = brandIdMap[brandId]?.cd || null;

    const data = { user_id: userId, biztp: brandCd };
    if (storeId) {
      data.store_id = storeId;
      dispatch(getQuickMenu({ ...api, data }));
    } else if (selectedBranchId) {
      data.store_id = selectedBranchId;
      dispatch(getQuickMenu({ ...api, data }));
    }
  }, [storeId, selectedBranchId]);
  return { menuItems, loading };
};

export default useQuickMenu;
